import { useNavigate } from 'react-router-dom';
import { HomeSettingsImg } from '../../../../assets/images';
import { useAuthContext } from '../../../../hooks';
import './Banner.scss';

const Banner = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();

  return (
    <div className="banner">
      <div className="banner__left">
        <h3>
          Welcome <span>{user ? user.displayName : 'User'}</span>
        </h3>
        <p>
          Ready to find your dream place? Clcik Discover, set your search
          settings and find the best place for you and your family
        </p>
        <button className="btn" onClick={() => navigate('/discover')}>
          Discover
        </button>
      </div>
      <div className="banner__right">
        <HomeSettingsImg />
      </div>
    </div>
  );
};

export default Banner;
